import { FunctionComponent, useMemo, Fragment } from "react";
import { PlanItem } from "@dto/PlanItem";
import {
  selectPlan,
  selectSelectedDayValue,
  selectStartingPoints,
} from "@store/plan/planReducer";
import { useAppSelector } from "@store/store";
import { calculateListItems, Day } from "./helpers";
import { Text } from "@ui-kit/Text/Text";
import { UserPlanItem } from "@modules/plan/UserPlanItem/UserPlanItem";
import { StartingPoint } from "@modules/plan/StartingPoint/StartingPoint";

import "./PlanItemList.css";

interface PlanItemListProps {
  planItems: PlanItem[];
}

const PlanItemList: FunctionComponent<PlanItemListProps> = ({ planItems }) => {
  const plan = useAppSelector(selectPlan);
  const selectedDayValue = useAppSelector(selectSelectedDayValue);
  const startingPoints = useAppSelector(selectStartingPoints);
  const hasPlanDates = (plan?.dayDuration ?? 0) > 0;
  const planItemsWithDays = useMemo(() => {
    return calculateListItems(
      plan,
      planItems,
      selectedDayValue,
      startingPoints,
    );
  }, [plan, planItems, selectedDayValue, startingPoints]);

  let ordinal = 0;

  return (
    <div className="plan-item-list-component">
      {!hasPlanDates && (
        <div>
          <StartingPoint dayIndex={null} />
        </div>
      )}
      {planItemsWithDays.map((item) => (
        <Fragment key={item.item.id}>
          {item.type === "planItem" && (
            <UserPlanItem
              key={item.item.id}
              planItem={item.item as PlanItem}
              ordinal={++ordinal}
            />
          )}
          {item.type === "day" && (
            <>
              <Text variant="fontHeadingMedium">
                {(item.item as Day).title}
              </Text>
              {item.dayIndex !== null && (
                <StartingPoint dayIndex={item.dayIndex} />
              )}
            </>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export { PlanItemList };
